export class Address {
    constructor(
        public readonly street_number: string,
        public readonly street: string,
        public readonly city: string,
        public readonly state: string,
        public readonly zip: string,
        public readonly formattedAddress: string
    ) {}
}
